const user = {
  state: {
    stuId: sessionStorage.getItem('stuId') || '',
    platform: sessionStorage.getItem('platform') || '0',
    token: sessionStorage.getItem('token') || '',
    ProfessionId: sessionStorage.getItem('professionId') || ''
  },

  mutations: {
    SET_stuId: (state, stuId) => {
      sessionStorage.setItem('stuId', stuId)
      state.stuId = sessionStorage.getItem('stuId')
    },
    SET_token: (state, token) => {
      sessionStorage.setItem('token', token)
      state.token = sessionStorage.getItem('token')
    },
    SET_platform: (state, platform) => {
      sessionStorage.setItem('platform', platform)
      state.platform = sessionStorage.getItem('platform')
    },
    SET_ProfessionId: (state, ProfessionId) => {
      sessionStorage.setItem('professionId', ProfessionId)
      state.ProfessionId = sessionStorage.getItem('ProfessionId')
    }
  },

  actions: {
    SetStuId ({ commit }, stuId) {
      commit('SET_stuId', stuId)
    },
    SetToken ({ commit }, token) {
      commit('SET_token', token)
    },
    SetPlatform ({ commit }, platform) {
      commit('SET_platform', platform)
    },
    SetProfessionId ({ commit }, ProfessionId) {
      commit('SET_ProfessionId', ProfessionId)
    }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js